module.exports = __webpack_public_path__ + "static/media/shared_bedroom.a44d0937.png";